import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Container, Button } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import ParentNavbar from '../student/ParentNavbar';
import MockScoreBoard from '../student/MockScoreBoard';

/**
 * Wrapper page that gives the parent-specific layout (navbar + container)
 * around the same MockScoreBoard component used by students.
 * The MockScoreBoard itself reads `childId` from useParams to fetch child data.
 */
const ParentScoreboardPage: React.FC = () => {
    const { childId } = useParams<{ childId: string }>();
    const navigate = useNavigate();

    return (
        <Box sx={(theme) => ({ minHeight: '100vh', backgroundColor: theme.palette.background.default })}>
            <ParentNavbar />
            <Container maxWidth="xl" sx={{ pt: 12, pb: 4 }}>
                <Button
                    startIcon={<ArrowLeft size={18} />}
                    onClick={() => navigate(`/parent/student/${childId}`)}
                    sx={(theme) => ({ mb: 2, color: theme.palette.text.secondary, textTransform: 'none', fontWeight: 600 })}
                >
                    Back to Details
                </Button>
                {/* MockScoreBoard detects childId from URL params and fetches child data */}
                <MockScoreBoard />
            </Container>
        </Box>
    );
};

export default ParentScoreboardPage;
